import React from "react";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
// import Debug from "../debug/bg";
import { default as classnames2 } from "classnames";

const useStyles = makeStyles({
	bottomFloat: {
		bottom: 0,
		position: "fixed",
		// ...Debug.debug1,
		// padding: 20,
		marginLeft: -24,
		// paddingLeft: "20px !important",
		// paddingRight: "20px !important",
		// paddingBottom: 16,
		paddingBottom: 16,
	},
	bottomNonFloat: {
		height: 65,
		// ...Debug.debug2,
	},
});

const BottomFloat = ({ children, className, style = {} }) => {
	const classes = useStyles();
	return (
		<>
			<Container
				maxWidth="sm"
				className={classnames2(classes.bottomFloat)}
				style={{
					...style,
					paddingBottom: process.env.REACT_APP_YES_APP === undefined ? 0 : 60,
					background:
						process.env.REACT_APP_YES_APP === undefined
							? "transparent"
							: "#fff",
				}}
			>
				{children}
			</Container>
			<Container maxWidth="sm" className={classes.bottomNonFloat}>
				&nbsp;
			</Container>
		</>
	);
};

export default BottomFloat;
